import type { ReactNode } from "react";
import { lazyWithPreload } from "@/lib/lazy";
import type { AdminSectionId } from "@/lib/navigation";

// Minden szekció külön chunk: az Analitika például a diagram-könyvtárral együtt csak akkor
// töltődik le, amikor először kell. Az `AdminLayout` a többit tétlen időben előtölti.
const AdminBookingsSection = lazyWithPreload(() =>
  import("./AdminBookingsSection").then((m) => ({ default: m.AdminBookingsSection })),
);
const UserBookingList = lazyWithPreload(() =>
  import("@/components/admin/UserBookingList").then((m) => ({ default: m.UserBookingList })),
);
const InvoiceList = lazyWithPreload(() =>
  import("@/components/admin/invoices/InvoiceList").then((m) => ({ default: m.InvoiceList })),
);
const Analytics = lazyWithPreload(() =>
  import("@/components/admin/Analytics").then((m) => ({ default: m.Analytics })),
);
const PricingSettingsForm = lazyWithPreload(() =>
  import("@/components/admin/PricingSettings").then((m) => ({ default: m.PricingSettingsForm })),
);
const Changelog = lazyWithPreload(() =>
  import("@/components/admin/Changelog").then((m) => ({ default: m.Changelog })),
);

/**
 * Szekció → nézet. A `Record` miatt új szekció felvétele (`adminSections`) fordítási
 * hibával jelez, amíg itt nincs hozzá nézet.
 */
export const adminSectionElements: Record<AdminSectionId, ReactNode> = {
  bookings: <AdminBookingsSection />,
  users: <UserBookingList />,
  invoices: <InvoiceList />,
  analytics: <Analytics />,
  settings: <PricingSettingsForm initialTab="pricing" />,
  changelog: <Changelog />,
};

/** Az összes szekció komponense - az előtöltéshez */
export const adminSectionComponents = [
  AdminBookingsSection,
  UserBookingList,
  InvoiceList,
  Analytics,
  PricingSettingsForm,
  Changelog,
];
